module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "photoUpload"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), (_vm.user === null) ? _c('div', {
    staticClass: "slide-container"
  }, [_c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./../assets/profile_off.svg"),
      "width": "50"
    }
  }), _c('br'), _c('br'), _vm._v("\n    Du måste vara inloggad för att bidra!\n    "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "black-on-white-butt",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("Logga in eller skapa ett konto")])], 1) : _vm._e(), _vm._v(" "), (_vm.user !== null) ? _c('div', {
    staticClass: "slide-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'register'),
      expression: "view === 'register'"
    }]
  }, [_vm._v("\n      Registrera dig för att ladda upp.\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'addemail'),
      expression: "view === 'addemail'"
    }]
  }, [_vm._v("\n      Registrera dig för att ladda upp.\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'upload'),
      expression: "view === 'upload'"
    }],
    staticClass: "slide-view"
  }, [_c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-icon"
  }), _vm._v(" "), (_vm.userOS === 'ios') ? _c('div', {
    staticClass: "black-on-white-butt margin-40",
    on: {
      "click": _vm.openInIos
    }
  }, [_vm._v("1. Fota med Lightroom")]) : _vm._e(), _vm._v(" "), (_vm.userOS === 'android') ? _c('a', {
    staticClass: "black-on-white-butt margin-40",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.adobe.lrmobile",
      "target": "_blank"
    },
    on: {
      "click": _vm.openInGoogle
    }
  }, [_vm._v("1. Fota med Lightroom")]) : _vm._e(), _vm._v(" "), (_vm.userOS === false) ? _c('a', {
    staticClass: "black-on-white-butt margin-40",
    attrs: {
      "href": "https://lightroom.adobe.com/",
      "target": "_blank"
    }
  }, [_vm._v("1. Fota med Lightroom")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "upload-file-label"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "id": "fileupload-input",
      "name": "fileupload",
      "accept": "image/*"
    },
    on: {
      "change": _vm.selectFile
    }
  }), _vm._v(" "), (_vm.isSaving) ? _c('span', [_vm._m(0)]) : _c('span', [_c('div', {
    staticClass: "blue-butt margin-20"
  }, [_vm._v("2. Ladda upp foto")])])]), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-white"
  }, [_c('div', {
    staticClass: "body-heading"
  }, [_vm._v("Tips: " + _vm._s(_vm.tip.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tip.body)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'confirm'),
      expression: "view === 'confirm'"
    }],
    staticClass: "confirm-upload"
  }, [_c('canvas', {
    attrs: {
      "id": "thumb-canvas"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "preview-image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-white padding-40"
  }, [_vm._v("\n        Användare i spelet bestämmer hur bra fotot är. I röstningen väljer man om man tycker ett foto är bra eller mindre bra.\n      ")]), _vm._v(" "), (_vm.uploading === false) ? _c('div', [_c('div', {
    staticClass: "blue-butt margin-40",
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("Skicka in foto")]), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })]) : _vm._e(), _vm._v(" "), (_vm.uploading === true) ? _c('div', [_c('div', {
    staticClass: "body-heading padding-40"
  }, [_vm._v("Laddar upp..." + _vm._s(_vm.uploadingPhotoProgress) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-heading margin-20"
  }, [_c('br'), _vm._v("Hämtar...")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6730eaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhotoUpload.vue
// module id = 124
// module chunks = 0